export default __webpack_public_path__ + "static/bentoCardBg-713e3bbf1a02c52cd12fac6dc00e55d1.png";